import {
  ActionIcon,
  Box,
  Group,
  Loader,
  Text,
  TextInput,
  rem,
} from "@mantine/core";
import { IconDots, IconSearch } from "@tabler/icons-react";
import { useClients } from "../../../hooks/useClients";
import { RowData } from "../../../types";
import CustomTable from "../../../components/tables/CustomTable";

export default function ClientList() {
  const { useListClients } = useClients();
  const { clients, loading } = useListClients();

  const headers = [
    { label: "Client Name", accessor: "clientName" },
    { label: "Phone Number", accessor: "phoneNumber" },
    { label: "Email Address", accessor: "email" },
    { label: "", accessor: "menu" },
  ];

  const data = clients?.map((client) => ({
    id: client.id,
    clientName: <Text size="sm">{client.name}</Text>,
    phoneNumber: <Text size="sm">{client.contacts}</Text>,
    email: <Text size="sm">{client?.email}</Text>,
    menu: "__commonData__",
  }));

  const commonData = {
    menu: (rowData: RowData) => (
      <ActionIcon variant="subtle">
        <IconDots size={24} stroke={1.5} />
      </ActionIcon>
    ),
  };

  return (
    <Box py={"md"}>
      {loading ? (
        <Group justify="center" my={"md"}>
          <Loader size={"sm"} />
          <Text>Loading...</Text>
        </Group>
      ) : (
        <Box>
          <Group justify="space-between">
            <TextInput
              variant="filled"
              leftSection={<IconSearch size={20} stroke={1.5} />}
              w={rem(250)}
              placeholder="Search client"
              styles={() => ({
                input: {
                  backgroundColor: "#f5f9fd",
                },
              })}
            />
          </Group>
          <CustomTable headers={headers} rows={data} commonData={commonData} />
        </Box>
      )}
    </Box>
  );
}
